import React, { useMemo } from "react";
import Preview from "../../WebMessenger/components/Preview";
import { ChatWindow } from "../types";
import { LanguageConfigModel, StyleConfigModel } from "../../types";
import CustomizableSelect from "../CustomizableSelect";
import ContentWidgetPreview from "./ContentWidgetPreview";

interface PreviewScreens {
  label: string;
  action: () => void;
  name: string;
}

interface Props {
  chatWindow: ChatWindow;
  previewScreens: PreviewScreens[];
  selectedScreen: string;
  setSelectedScreen: (screen: string) => void;
}

export default function ChatWindowPreview({
  previewScreens,
  selectedScreen,
  setSelectedScreen,
  chatWindow
}: Props) {
  const selectedOption = useMemo(() => {
    const matchedScreen = previewScreens.find(
      (screen) => screen.name === selectedScreen
    );

    if (!matchedScreen) return null;

    return {
      label: matchedScreen.label,
      action: () => setSelectedScreen(matchedScreen.name)
    };
  }, [previewScreens, selectedScreen, setSelectedScreen]);

  return (
    <div className="w-full">
      <div className="flex items-center justify-between border-b border-slate-300 p-6">
        <div className="text-lg font-medium">Chat Window Preview</div>
        <div className="w-60">
          <CustomizableSelect
            options={previewScreens.map((screen) => ({
              label: screen.label,
              name: screen.name,
              action: () => setSelectedScreen(screen.name)
            }))}
            value={selectedOption}
            onChange={(option) => {
              const screen = option.label.replace("Connect via ", "");
              setSelectedScreen(option.name || screen);
            }}
          />
        </div>
      </div>
      <div className="flex justify-center">
        {selectedScreen === "Content" ? (
          <ContentWidgetPreview chatWindow={chatWindow} />
        ) : (
          <Preview type={selectedScreen} workingChatWindow={chatWindow} />
        )}
      </div>
    </div>
  );
}
